exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".basePage[data-v-7dfc79c6]{height:100%;width:100%;margin:0;padding:0;position:relative}.api-line-char-cla[data-v-7dfc79c6]{height:41.666667rem;background-color:#fff;border-radius:.333333rem;margin-left:1rem;-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1}@media screen and (max-width:980px){.api-line-char-cla[data-v-7dfc79c6]{margin-left:0;margin-top:1rem}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-7dfc79c6","scoped":true,"hasInlineConfig":false}!./node_modules/px2rem-loader?{"remUnit":12}!./node_modules/less-loader/dist/cjs.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/modules/statistics/apiStatistics/apiLineChart.vue
// module id = nEaB
// module chunks = 7